// extracted by mini-css-extract-plugin
export var banner = "_rm-0";
export var settingRow = "_rm-2";
export var titleIcon = "_rm-1";